import classNames from 'classnames';
import React from 'react';
import { EnvelopeIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './PaneBottomContactPanel.scss';

type Props = {
  email: string;
  isMobileHidden?: boolean;
};

export const PaneBottomContactPanel: React.FC<Props> = ({ email, isMobileHidden = false }) => (
  <div className={classNames(style.container, { [style.mobile_hidden]: isMobileHidden })}>
    <Text variant="sm" color={Color.GRAY}>
      © Cairns Health 2025
    </Text>
    <div className={style.email_container}>
      <EnvelopeIcon />
      <Text variant="sm">
        <a href={`mailto:${email}`} className={style.email}>
          {email}
        </a>
      </Text>
    </div>
  </div>
);
